import React from "react";
import { useSelector } from "react-redux";
import Loader from "./Loader";

const Home = () => {
  const loading = useSelector((state) => state?.auth?.loading);
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      {loading ? <Loader loading={loading} /> : ""}
      <div className="text-center w-full md:max-w-[297px] lg:w-[297px] md:pr-[33px] flex items-center justify-center max-md:mb-[30px]">
        <img
          src="/logo.svg"
          className="w-full h-[auto] md:max-w-[290px] max-w-[180px]"
          alt="hyperapt"
        />
      </div>
      {/* <div className="gap-6 max-w-[800px] flex items-center justify-center flex-wrap">
        <button
          className="max-w-[30%] min-w-[200px] w-full px-8 py-4 bg-red-500 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-red-700"
          onClick={() => navigate("/admin/login")}
        >
          Admin
        </button>
        <button
          className="max-w-[30%] min-w-[200px] w-full px-8 py-4 bg-red-500 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-red-700"
          onClick={() => navigate("/store/login")}
        >
          Store
        </button>
        <button
          className="max-w-[30%] min-w-[200px] w-full px-8 py-4 bg-red-500 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-red-700"
          onClick={() => navigate("/doctor/login")}
        >
          Doctor
        </button>
      </div> */}
    </div>
  );
};

export default Home;
